import React, { ChangeEvent, useState } from 'react'
import mapper from '../../../_endpoints'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import {
  Alert,
  ModalBody,
  Card,
  Spinner
  // @ts-ignore
} from 'reactstrap'
// @ts-ignore
import { Checkbox } from 'dsm-react-lib'
import { usePost } from '../../../_hooks/usePost'
import { useFetch } from '../../../_hooks/useFetch'
import {
  AttestationTitle,
  StyledButton,
  StyledCard,
  StyledFrame,
  StyledHeader,
  StyledModal,
  StyledTitle
} from './styles'
import { CloseBtn } from '../../../styles/common'
import { useLocation } from 'react-router-dom'
import { useTrackEvent } from '@microsoft/applicationinsights-react-js'
import { appInsights } from '../../../_services/AppInsights'
import { EventType } from '../../../utility/types'
import { setAliOpenSideBar } from '../../../_redux/actions/chatbotActions'
import { checkIsDrawerMode } from '../../../views/_pages/Chatbot/utils/helpers'
import { IconAlertCircle } from '@tabler/icons-react'

interface FlyerProps {
  isOpen: boolean
  toggle: any
  onClose: () => void
  backdrop?: string | boolean
  header?: string
  src?: string
  isAttestationWindow?: boolean
  setHasAttested?: any
}

const attestations = [
  {
    id: 1,
    title:
      'I understand that the AI and it’s outputs are designed to enhance productivity and not to serve as the sole basis for decision-making.'
  },
  {
    id: 2,
    title:
      'I understand that it’s important to use AI systems ethically and responsibly, and to comply with relevant laws and regulations.'
  },
  {
    id: 3,
    title:
      'I understand that data I upload must: (i) not include Personally identifiable information (ii) be in adherence with existing data retention requirements (iii) be used in a way that is intended within the original source.'
  },
  {
    id: 4,
    title:
      'I understand that while we have robust safeguards in place, it’s important to note that the system may occasionally generate bias, incorrect or misleading information. It is my responsibility to use human oversight to validate the output information and ensure that it is fair and accurate.'
  },
  {
    id: 5,
    title:
      'Individuals are explicitly reminded of their responsibilities to abide by the Data / Privacy / Information Technology Risk Policies and Information Security Code of Practice (ISCOP).'
  },
  {
    id: 6,
    title:
      'I agree to provide feedback to the Centrali support team if I notice any issues with the quality or suitability of the output by the AI.'
  },
  {
    id: 7,
    title:
      'I understand that my interactions with the AI system may be logged and monitored to improve its performance and ensure its responsible use.'
  }
]

export const Flyer: React.FC<FlyerProps> = ({
  isOpen,
  toggle,
  onClose,
  backdrop = true,
  header,
  src,
  isAttestationWindow,
  setHasAttested
}: FlyerProps) => {
  const [checkedAttestations, setCheckedAttestations] = useState<any[]>([])
  const [isValid, setIsValid] = useState<boolean>()
  const [isLoading, postUserDetails] = usePost()
  const dispatch = useDispatch()
  const location = useLocation()
  const profileInfo = useSelector((state: RootStateOrAny) => state?.profileReducer?.profile)
  //@ts-ignore
  const trackJoinMode = useTrackEvent(appInsights, EventType.JoinEarlyAdopter)
  const searchParams = new URLSearchParams(location.search)
  const source = searchParams.get('source')
  const isDrawerMode = checkIsDrawerMode()

  const onJoin = async () => {
    const isAllChecked = checkedAttestations.length === attestations.length
    setIsValid(isAllChecked)
    if (!isAllChecked) return

    // register the user in identity service
    const response = await postUserDetails({
      url: mapper.bff.saveUserDetails,
      data: {
        isRegisteredForAli: true
      }
    })
    setTimeout(() => {
      dispatch(setAliOpenSideBar(true))
    }, 500)

    if (response.status === 'Success') {
      trackJoinMode({ source: source || 'portal' })
      const updateUserProfileInfo = {
        ...profileInfo,
        userMetaData: {
          ...profileInfo?.userMetaData,
          isRegisteredForAli: true
        }
      }
      dispatch({ type: 'SET_PROFILE', payload: updateUserProfileInfo })
      toggle()
      setHasAttested(true)
    }
  }

  const onCheckAttestations = (e: ChangeEvent<HTMLInputElement>, id: number) => {
    const index = checkedAttestations.indexOf(id)
    let clone
    if (index === -1) {
      clone = [...checkedAttestations, id]
    } else {
      clone = checkedAttestations.filter((_, i) => i !== index)
    }
    setCheckedAttestations(clone)
  }

  return (
    <StyledModal
      size={'lg'}
      isOpen={isOpen}
      toggle={(!isAttestationWindow || isDrawerMode) && onClose}
      backdrop={backdrop}
      className="modal-dialog-centered"
      contentClassName="pt-0">
      <StyledHeader
        theme={'primary'}
        toggle={(!isAttestationWindow || isDrawerMode) && onClose}
        close={(!isAttestationWindow || isDrawerMode) && <CloseBtn size={20} onClick={onClose} />}
        tag="div">
        <StyledTitle className="modal-title">{header}</StyledTitle>
      </StyledHeader>
      <ModalBody className="flex-grow-1 p-2">
        <StyledFrame src={src} allowFullScreen />
        <StyledCard>
          {attestations.map(({ id, title }: { id: number; title: string }) => (
            <div key={id} className="d-flex pt-1 pb-1">
              <Checkbox
                color="primary"
                variant="custom"
                id={`consentCheckbox-${id}`}
                name={`consentCheckbox-${id}`}
                onChange={(e: ChangeEvent<HTMLInputElement>) => onCheckAttestations(e, id)}
              />
              <AttestationTitle>{title}</AttestationTitle>
            </div>
          ))}
        </StyledCard>
        {isValid !== undefined && !isValid && (
          <Alert color="danger mt-1" isOpen={!isValid}>
            <div className="alert-body">
              <IconAlertCircle size={15} />
              <span className="ms-1">
                In order to proceed you must accept the terms and conditions for using Centrali AI
              </span>
            </div>
          </Alert>
        )}

        <div className="d-flex justify-content-center">
          <StyledButton
            size="large"
            color="secondary"
            className="mr-0"
            onClick={onJoin}
            disabled={isLoading}
            label={
              isLoading ? (
                <>
                  Joining...
                  <Spinner />
                </>
              ) : (
                'Join now'
              )
            }></StyledButton>
        </div>
      </ModalBody>
    </StyledModal>
  )
}
